import { gql } from "apollo-angular";

export const GETALL_TEST_CASES_QUERY_PAGINATED = gql`query configuratorTestCasesPagination($BaseInput: BaseInput) {
  configuratorTestCasesPagination(BaseInput: $BaseInput) {
      TotalItemsCount
      Items {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
        Approval {
          Id
          Status
          ItemVersion
        }
      }
  }
}
`

export const GETALL_TEST_CASES_QUERY = gql`query configuratorAllTestCases($Company: String, $RegBy: String, $OrgGroup: String) {
    configuratorAllTestCases(Company: $Company, RegBy: $RegBy, OrgGroup: $OrgGroup) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
        Approval {
            Id
            Status
            ItemVersion
        }
    }
  }
  `


export const GET_TEST_CASE_QUERY = gql`query configuratorTestCaseById($Uid: String!) {
    configuratorTestCaseById(Uid: $Uid) {
        responseMessages
        returnValue
        success
    }
  }
  `


export const GET_TEST_CASE_UI_TEMPLATE_QUERY = gql`query configuratorTestCaseUiTemplate {
    configuratorTestCaseUiTemplate {
        Name
        Category
        DefaultValue
        FieldType
        IsMultiValue
        HasHierarchyValues
        IsReadOnly
        Label
        IsRequired
        Order
        Tooltip
        ValueList
    }
  }
  `
export const GET_TEST_CASE_SEARCH_UI_TEMPLATE_QUERY = gql`query configuratorTestCaseSearchUiTemplate {
    configuratorTestCaseSearchUiTemplate {
        Name
        Label
        Category
        DefaultValue
        Order
        FieldType
        Tooltip
        IsReadOnly
        IsRequired
        IsMultiValue
        HasHierarchyValues
        ValueList
    }
  }
  `

export const SEARCH_TEST_CASE_QUERY = gql`query configuratorSearchTestCase($TestCase: TestCaseInput) {
  configuratorSearchTestCase(TestCase: $TestCase) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
}
`
